import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';

import GlobalCVPBanner from '@/v2/../components/GlobalCVPBanner';

const Content = styled(GlobalCVPBanner)`
  & > div {
    padding: 0;
  }
`;

const CustomerValuePropositions = () => {
  return (
    <Box
      backgroundColor="white"
      borderColor="greys.alto"
      py={['0', null, '1']}
      borderTop="1"
      borderBottom="1"
    >
      <Content />
    </Box>
  );
};

export default CustomerValuePropositions;
